/* eslint-disable react/display-name */
import {
  Callout,
  Expander,
  Heading,
  HorizontalRule,
  Link,
  ListItem,
  OrderedList,
  Paragraph,
  Reveal,
  Section,
  UnorderedList,
} from '@piggybank/core';
import { Hint } from '@piggybank/form';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isPlainObject from 'lodash/isPlainObject';
import startsWith from 'lodash/startsWith';
import update from 'lodash/update';
import React from 'react';

const decorateProps = ({ decorators, ...props }, componentKey) => {
  if (decorators && decorators[componentKey]) {
    return decorators[componentKey](props);
  }

  return props;
};

const mapUnorderedList = props => {
  // check if all child list item has '[tick]' prefix
  const isTickList =
    isArray(get(props, 'children')) &&
    props.children
      .filter(listItem => isPlainObject(listItem))
      .every(listItem =>
        startsWith(get(listItem, 'props.children.0'), '[tick] ')
      );

  // if it's a tick list, remove '[tick]' prefix from each list item and set list type to 'tick'
  if (isTickList) {
    const tickListProps = {
      ...props,
      children: props.children.map(listItem =>
        isPlainObject(listItem)
          ? update(listItem, 'props.children.0', value =>
              value.replace('[tick] ', '')
            )
          : listItem
      ),
    };

    return (
      <UnorderedList {...decorateProps(tickListProps, 'ul')} type="tick" />
    );
  }

  return <UnorderedList {...decorateProps(props, 'ul')} />;
};

export const h1 = props => (
  <Heading level={1} {...decorateProps(props, 'h1')} />
);

export const h2 = props => (
  <Heading accentBar level={2} {...decorateProps(props, 'h2')} />
);

export const h3 = props => (
  <Heading level={3} {...decorateProps(props, 'h3')} />
);

export const h4 = props => (
  <Heading level={4} {...decorateProps(props, 'h4')} />
);

export const h5 = props => (
  <Heading level={5} {...decorateProps(props, 'h5')} />
);

export const h6 = props => (
  <Heading level={6} {...decorateProps(props, 'h6')} />
);

export const hr = props => <HorizontalRule {...decorateProps(props, 'hr')} />;

export const ul = mapUnorderedList;

export const ol = props => <OrderedList {...decorateProps(props, 'ol')} />;

export const li = props => <ListItem {...decorateProps(props, 'li')} />;

export const p = props => (
  <Paragraph {...decorateProps(props, 'p')}></Paragraph>
);

export const a = props => <Link external {...decorateProps(props, 'a')} />;

export const blockquote = props => (
  <Hint {...decorateProps(props, 'blockquote')} />
);

export const callout = props => (
  <Callout {...decorateProps(props, 'callout')} />
);

export const expander = props => (
  <Expander {...decorateProps(props, 'expander')} />
);

export const reveal = props => <Reveal {...decorateProps(props, 'reveal')} />;

export const section = props => (
  <Section {...decorateProps(props, 'section')} />
);
